import { render, staticRenderFns } from "./SubmissionSettledDialog.vue?vue&type=template&id=7012b954&"
import script from "./SubmissionSettledDialog.vue?vue&type=script&lang=ts&"
export * from "./SubmissionSettledDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SubmissionSettledDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports